var _style, _rect, _rect2, _rect3, _rect4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuperb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 343 32.5",
    style: {
      enableBackground: "new 0 0 343 32.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2B2C2E;}\r\n\t.st1{fill:#51555D;}\r\n\t.st2{fill:#7A7F86;}\r\n\t.st3{fill:#A3A7AD;}\r\n\t.st4{fill:#DF6E00;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 0,
    className: "st0",
    width: 289.5,
    height: 32.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 294.4,
    y: 0,
    className: "st1",
    width: 17.6,
    height: 32.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 316.2,
    y: 0,
    className: "st2",
    width: 13.3,
    height: 32.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 333.4,
    y: 0,
    className: "st3",
    width: 9.1,
    height: 32.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M16.7,12.4c0-0.6-0.3-0.9-0.9-0.9h-2.8c-0.6,0-0.9,0.3-0.9,0.9v1.3c0,0.7,0.3,0.9,0.9,1l3,0.7 c1.3,0.3,2.3,0.7,2.3,2.3v1.7c0,1.5-0.8,2.2-2.2,2.2h-3.3c-1.5,0-2.2-0.8-2.2-2.2v-1.2h1.5v1.2c0,0.6,0.3,0.9,0.9,0.9h3 c0.6,0,0.9-0.3,0.9-0.9v-1.5c0-0.7-0.3-0.9-0.9-1.1l-3-0.7c-1.3-0.3-2.3-0.7-2.3-2.3v-1.5c0-1.5,0.8-2.2,2.2-2.2H16 c1.5,0,2.2,0.8,2.2,2.2v1.1h-1.5V12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M28.8,19.4c0,1.5-0.8,2.2-2.2,2.2h-3.5c-1.5,0-2.2-0.8-2.2-2.2v-9.3h1.5v9.2c0,0.6,0.3,0.9,0.9,0.9h3.2 c0.6,0,0.9-0.3,0.9-0.9v-9.2h1.5V19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37.2,10.1c1.5,0,2.2,0.8,2.2,2.2v2.7c0,1.5-0.8,2.2-2.2,2.2h-4.1v4.4h-1.5V10.1H37.2z M37,15.9 c0.6,0,0.9-0.3,0.9-0.9v-2.6c0-0.6-0.3-0.9-0.9-0.9h-3.9v4.3H37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48.8,10.1v1.4h-5.7v3.5h4.8v1.4h-4.8v3.8h5.7v1.4h-7.3V10.1H48.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M57.6,21.7l-2.3-4.6h-2.7v4.6H51V10.1h5.6c1.5,0,2.2,0.8,2.2,2.2v2.4c0,1.3-0.7,2.1-1.9,2.2l2.3,4.6H57.6z  M56.5,15.7c0.6,0,0.9-0.3,0.9-0.9v-2.4c0-0.6-0.3-0.9-0.9-0.9h-3.9v4.1H56.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.1,10.1c1.5,0,2.2,0.8,2.2,2.2v1.7c0,0.8-0.4,1.4-1,1.7c0.8,0.3,1.2,0.9,1.2,1.7v1.9c0,1.5-0.8,2.2-2.2,2.2 h-5.7V10.1H67.1z M66.9,15.1c0.6,0,0.9-0.3,0.9-0.9v-1.8c0-0.6-0.3-0.9-0.9-0.9H63v3.6H66.9z M67,20.3c0.6,0,0.9-0.3,0.9-0.9v-2.1 c0-0.6-0.3-0.9-0.9-0.9h-4v3.8H67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77.8,21.7c-1.5,0-2.2-0.8-2.2-2.2v-7c0-1.5,0.8-2.2,2.2-2.2h3.5c1.5,0,2.2,0.8,2.2,2.2v1.4h-1.5v-1.4 c0-0.6-0.3-0.9-0.9-0.9h-3.1c-0.6,0-0.9,0.3-0.9,0.9v6.9c0,0.6,0.3,0.9,0.9,0.9h3.1c0.6,0,0.9-0.3,0.9-0.9V18h1.5v1.4 c0,1.5-0.8,2.2-2.2,2.2H77.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M87.8,21.7c-1.5,0-2.2-0.8-2.2-2.2v-7c0-1.5,0.8-2.2,2.2-2.2h3.7c1.5,0,2.2,0.8,2.2,2.2v7 c0,1.5-0.8,2.2-2.2,2.2H87.8z M87.1,19.4c0,0.6,0.3,0.9,0.9,0.9h3.3c0.6,0,0.9-0.3,0.9-0.9v-6.9c0-0.6-0.3-0.9-0.9-0.9H88 c-0.6,0-0.9,0.3-0.9,0.9V19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.8,10.1v11.5h-1.5l-5.5-9.2v9.2h-1.4V10.1H98l5.4,9.1v-9.1H104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M113.5,12.4c0-0.6-0.3-0.9-0.9-0.9h-2.8c-0.6,0-0.9,0.3-0.9,0.9v1.3c0,0.7,0.3,0.9,0.9,1l3,0.7 c1.3,0.3,2.3,0.7,2.3,2.3v1.7c0,1.5-0.8,2.2-2.2,2.2h-3.3c-1.5,0-2.2-0.8-2.2-2.2v-1.2h1.5v1.2c0,0.6,0.3,0.9,0.9,0.9h3 c0.6,0,0.9-0.3,0.9-0.9v-1.5c0-0.7-0.3-0.9-0.9-1.1l-3-0.7c-1.3-0.3-2.3-0.7-2.3-2.3v-1.5c0-1.5,0.8-2.2,2.2-2.2h3.1 c1.5,0,2.2,0.8,2.2,2.2v1.1h-1.5V12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M121.5,11.5v10.1h-1.5V11.5h-3.3v-1.4h8.1v1.4H121.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M133.2,21.7l-2.3-4.6h-2.7v4.6h-1.5V10.1h5.6c1.5,0,2.2,0.8,2.2,2.2v2.4c0,1.3-0.7,2.1-1.9,2.2l2.3,4.6H133.2z  M132.1,15.7c0.6,0,0.9-0.3,0.9-0.9v-2.4c0-0.6-0.3-0.9-0.9-0.9h-3.9v4.1H132.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M145,19.4c0,1.5-0.8,2.2-2.2,2.2h-3.5c-1.5,0-2.2-0.8-2.2-2.2v-9.3h1.5v9.2c0,0.6,0.3,0.9,0.9,0.9h3.2 c0.6,0,0.9-0.3,0.9-0.9v-9.2h1.5V19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M149.7,21.7c-1.5,0-2.2-0.8-2.2-2.2v-7c0-1.5,0.8-2.2,2.2-2.2h3.5c1.5,0,2.2,0.8,2.2,2.2v1.4h-1.5v-1.4 c0-0.6-0.3-0.9-0.9-0.9h-3.1c-0.6,0-0.9,0.3-0.9,0.9v6.9c0,0.6,0.3,0.9,0.9,0.9h3.1c0.6,0,0.9-0.3,0.9-0.9V18h1.5v1.4 c0,1.5-0.8,2.2-2.2,2.2H149.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M161.5,11.5v10.1H160V11.5h-3.3v-1.4h8.1v1.4H161.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M166.7,10.1h1.5v11.5h-1.5V10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M173.1,21.7c-1.5,0-2.2-0.8-2.2-2.2v-7c0-1.5,0.8-2.2,2.2-2.2h3.7c1.5,0,2.2,0.8,2.2,2.2v7 c0,1.5-0.8,2.2-2.2,2.2H173.1z M172.4,19.4c0,0.6,0.3,0.9,0.9,0.9h3.3c0.6,0,0.9-0.3,0.9-0.9v-6.9c0-0.6-0.3-0.9-0.9-0.9h-3.3 c-0.6,0-0.9,0.3-0.9,0.9V19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M190.1,10.1v11.5h-1.5l-5.5-9.2v9.2h-1.4V10.1h1.7l5.4,9.1v-9.1H190.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M203.1,12.4c0-0.6-0.3-0.9-0.9-0.9H199c-0.6,0-0.9,0.3-0.9,0.9v6.9c0,0.6,0.3,0.9,0.9,0.9h3.2 c0.6,0,0.9-0.3,0.9-0.9V17h-2.7v-1.4h4.2v3.8c0,1.5-0.8,2.2-2.2,2.2h-3.6c-1.5,0-2.2-0.8-2.2-2.2v-7c0-1.5,0.8-2.2,2.2-2.2h3.6 c1.5,0,2.2,0.8,2.2,2.2v1.2h-1.5V12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M213.8,21.7l-2.3-4.6h-2.7v4.6h-1.5V10.1h5.6c1.5,0,2.2,0.8,2.2,2.2v2.4c0,1.3-0.7,2.1-1.9,2.2l2.3,4.6H213.8z  M212.7,15.7c0.6,0,0.9-0.3,0.9-0.9v-2.4c0-0.6-0.3-0.9-0.9-0.9h-3.9v4.1H212.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M219.7,21.7c-1.5,0-2.2-0.8-2.2-2.2v-7c0-1.5,0.8-2.2,2.2-2.2h3.7c1.5,0,2.2,0.8,2.2,2.2v7 c0,1.5-0.8,2.2-2.2,2.2H219.7z M219,19.4c0,0.6,0.3,0.9,0.9,0.9h3.3c0.6,0,0.9-0.3,0.9-0.9v-6.9c0-0.6-0.3-0.9-0.9-0.9h-3.3 c-0.6,0-0.9,0.3-0.9,0.9V19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M236.1,19.4c0,1.5-0.8,2.2-2.2,2.2h-3.5c-1.5,0-2.2-0.8-2.2-2.2v-9.3h1.5v9.2c0,0.6,0.3,0.9,0.9,0.9h3.2 c0.6,0,0.9-0.3,0.9-0.9v-9.2h1.5V19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M244.4,10.1c1.5,0,2.2,0.8,2.2,2.2v2.7c0,1.5-0.8,2.2-2.2,2.2h-4.1v4.4h-1.5V10.1H244.4z M244.3,15.9 c0.6,0,0.9-0.3,0.9-0.9v-2.6c0-0.6-0.3-0.9-0.9-0.9h-3.9v4.3H244.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M254.2,10.1v10.1h5.3v1.4h-6.9V10.1H254.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M263.9,11.5v10.1h-1.5V11.5H259v-1.4h8.1v1.4H263.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M274.8,10.1c1.5,0,2.2,0.8,2.2,2.2v7c0,1.5-0.8,2.2-2.2,2.2H269V10.1H274.8z M274.6,20.3 c0.6,0,0.9-0.3,0.9-0.9v-6.9c0-0.6-0.3-0.9-0.9-0.9h-4v8.7H274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M279.1,21.7v-1.8h1.7v1.8H279.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperb);
export default __webpack_public_path__ + "static/media/superb.d5593c4e53ca9fb7ba7f7c35b5123d0f.svg";
export { ForwardRef as ReactComponent };